import { connect } from 'react-redux'
import { pathToProduct } from './data'

import Component from './component'

const mapStateToProps = ({ router, currentUserManager }) => {
  const { location } = router || {}
  const { pathname } = location || {}
  const product = pathToProduct(pathname)

  const { currentUser } = currentUserManager || {}
  const { displayName } = currentUser || {}
  return {
    product,
    name: displayName,
  }
}

export default connect(mapStateToProps)(Component)
